import { useSelector } from 'react-redux';
import { getUserInventoryElement } from '../../selectors';
import { IStore } from 'store/interface';
import { IFastInventoryElement } from '../../interfaces';

export const useFastInventoryElement = (idx: number) => ({
  item: useSelector<IStore, IFastInventoryElement>(getUserInventoryElement(idx)),
});
